import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';
import axios from 'axios';

const Review = () => {

    // State Variables
    const { globalSearch } = useSearch();
    const [deliveries, setDeliveries] = useState([]);
    const [filteredDeliveries, setFilteredDeliveries] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    const urlmain = API_BASE_URL
    const token = decryptToken("accessToken") || ""
    const [load, setLoad] = useState(false);


    // Effect to handle filtering
    useEffect(() => {
        const filtered = deliveries.filter((delivery) =>
            Object.values(delivery).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredDeliveries(filtered);
        setCurrentPage(1);
    }, [globalSearch, deliveries]);

    // Pagination Logic
    const totalPages = filteredDeliveries.length ? Math.ceil(filteredDeliveries.length / itemsPerPage) : 1;
    const currentData = filteredDeliveries.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const paginate = (pageNumber) => setCurrentPage(pageNumber);



    // Handle Delete
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${urlmain}/review/${id}`, {
                        method: 'DELETE',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });

                    const res = await response.json();

                    if (response.ok) {
                        setDeliveries(prev => prev.filter(p => p.id !== id));
                        Swal.fire('Deleted!', res.message || 'Delivery has been deleted.', 'success');
                    } else {
                        Swal.fire('Error!', res.message || 'Failed to delete pincode.', 'error');
                    }
                } catch (error) {
                    console.error('Delete failed', error);
                    Swal.fire('Error!', 'Something went wrong.', 'error');
                }
            }
        });
    };

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    const toggleStatus = async (id) => {


        try {
            const res = await axios.put(
                `${urlmain}/review/toggle-status/${id}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res.status === 200) {
                const updatedStatus = res.data.updatedProduct.status;

                // Update local state
                const updatedEquipments = deliveries.map((item) =>
                    item.id === id ? { ...item, status: updatedStatus } : item
                );

                setDeliveries(updatedEquipments);
                toast.success(`Status updated to ${updatedStatus}`);
            }
        } catch (error) {
            console.error("Failed to toggle status:", error);
            toast.error("Failed to toggle status");
        }
    };

    const fetchDelivery = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${urlmain}/review/all`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            console.log(res)
            setDeliveries(res);
        } catch (error) {
            console.error(error)
        } finally {
            setLoad(false)
        }
    }


    useEffect(() => {
        fetchDelivery();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }


    return (
        <>

            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Review</h1>

                </div>

                {/* Search Filter */}
                {/* <div className="filter-search">

                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

                {/* Customer Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Title</th>
                                <th>Rating</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>{customer.full_name}</td>
                                        <td>{customer.title}</td>
                                        <td>{customer.rating}</td>
                                        <td>
                                            <button className="toggle-button" onClick={() => toggleStatus(customer.id)}>
                                                <i
                                                    className={
                                                        customer.status === 'Active'
                                                            ? 'fas fa-toggle-on'
                                                            : 'fas fa-toggle-off'
                                                    }
                                                ></i>
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(customer.id)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>No delivery found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="ecom-responsive-cards">
                    {currentData.length === 0 ? (
                        <p style={{ textAlign: "center", margin: "50px" }}>No Delivery Added</p>
                    ) : (
                        currentData.map((group, index) => (
                            <div className="ecom-responsive-card" key={index}>
                                <div className="ecom-responsive-header">
                                    <p onClick={() => handleDelete(group.id)}>
                                        <Trash2 size={20} style={{ marginRight: 4 }} /> <span>Delete</span>
                                    </p>
                                </div>

                                <div className="ecom-responsive-body">
                                    <div className="ecom-responsive-left">
                                        <h2>{group.full_name || "Not Provided"}</h2>
                                        <p>Title: {group.title}</p>
                                        <p>Rating: {group.rating}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}

            </div>



        </>
    );
};

export default Review;
